// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveUserDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import UserDTO from '../models/UserDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    userId: string | null;
    user: UserDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            userId: '00000000-0000-0000-0000-000000000000',
            user: null,
        },
        initValues);
    },
    userId: 'userId',
    user: 'user',
}

interface Result extends ResultDTO {
    user: UserDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            user: null,
        },
        initValues);
    },
    user: 'user',
}

export { Request, Result };